import React from 'react';
import EntityAttachmentsCard from '@/components/documents/EntityAttachmentsCard';
import InheritedAttachmentsCard from '@/components/documents/InheritedAttachmentsCard';
import { SCM_ATTACHMENT_UPLOAD_HINT } from '@/constants/document-entity-types';

export interface ProcurementAttachmentsCardProps {
  entityType: string;
  entityId?: string | null;
  title?: string;
  readOnly?: boolean;
  queryKeyPrefix: string[];
  /** Also list read-only attachments from upstream documents (default on for supply chain documents). */
  showInherited?: boolean;
}

export const ProcurementAttachmentsCard: React.FC<ProcurementAttachmentsCardProps> = ({
  entityType,
  entityId,
  title = 'Attachments',
  readOnly = false,
  queryKeyPrefix,
  showInherited = true,
}) => {
  if (!entityId) return null;
  return (
    <div style={{ marginTop: 16 }}>
      <EntityAttachmentsCard
        entityType={entityType}
        entityId={entityId}
        title={title}
        readOnly={readOnly}
        queryKeyPrefix={queryKeyPrefix}
        uploadHint={SCM_ATTACHMENT_UPLOAD_HINT}
      />
      {showInherited ? (
        <InheritedAttachmentsCard
          trailDomain="procurement"
          entityType={entityType}
          entityId={entityId}
          queryKeyPrefix={queryKeyPrefix}
        />
      ) : null}
    </div>
  );
};

export default ProcurementAttachmentsCard;
